type TranslatorWithHas = {
  has(key: never): boolean;
};

export const translateWithFallback = <TTranslator extends TranslatorWithHas>(translator: TTranslator, key: string) => {
  const typedTranslator = translator as TTranslator & ((message: never) => string);
  const typedKey = key as never;

  return typedTranslator.has(typedKey) ? typedTranslator(typedKey) : key;
};
